import { makeStyles } from 'tss-react/mui';

const name = 'ChainOverview';

export const useChainOverviewStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  left: {
    display: 'flex',
    gap: theme.spacing(2),

    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
    },
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));
